import { render, staticRenderFns } from "./edit-modal.vue?vue&type=template&id=6fb67b3e&scoped=true&"
import script from "./edit-modal.vue?vue&type=script&lang=js&"
export * from "./edit-modal.vue?vue&type=script&lang=js&"
import style0 from "./edit-modal.vue?vue&type=style&index=0&id=6fb67b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb67b3e",
  null
  
)

export default component.exports